import React from 'react';
import {
  AR, BO, BR, CA, CL, CN, CO, DE, EC, ES,
  FR, GB, IT, JP, MX, PE, PY, US, UY, VE,
} from 'country-flag-icons/react/3x2';
import './CountryFlag.css';

const FLAGS = {
  AR, BO, BR, CA, CL, CN, CO, DE, EC, ES,
  FR, GB, IT, JP, MX, PE, PY, US, UY, VE,
};

const CountryFlag = ({ code, className = 'country-flag', title }) => {
  const normalized = String(code || '').toUpperCase();
  const Flag = FLAGS[normalized];

  if (!Flag) {
    return (
      <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3.5 12h17M12 3c2.4 2.5 3.6 5.5 3.6 9S14.4 18.5 12 21M12 3C9.6 5.5 8.4 8.5 8.4 12S9.6 18.5 12 21" fill="none" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    );
  }

  return (
    <Flag
      className={className}
      aria-label={title ? `Bandera de ${title}` : undefined}
    />
  );
};

export default CountryFlag;
